import { WORK_ORDER_TASKS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/work_order_tasks_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['workOrderTasksIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
